import React from 'react';
import Params from '../../../../Types/ParamsPicklist';
import { Box, Grid } from '@mui/material';
import SelectMultipleOptionPanier from '../../../SelectMultipleOptionPanier';

let searchFinancement: Params = { CodeAgence: '', Table: "TypeGarantie", Colonne1: "CodeTypeGarantie", Colonne2: "LibelleGarantie", Colagence: '101', Choix: 22 };
let searchPlancp: Params = { CodeAgence: '', Table: "PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL",Colagence: "", Choix: 39,tablelength:'societe',collength:'LenPlancp' }
  
let searchActif: Params = { CodeAgence: '', Table: "CategorieActif", Colonne1: "CodeCategorie", Colonne2: "Libelle", Colagence: '101', Choix: 22 };
// let searchOperat: Params = { ... }; // commenté car Frais est déjà dans Tab1

function Tab3(props: { form?: any }) {
    return (
        <div className='tabItem'>
            <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>
                <Grid container spacing={0}>
                    <Grid item xs={12} md={6} lg={6}>
                        <SelectMultipleOptionPanier
                            form={props.form}
                            Size="large"
                            width={5}
                            notRequired
                            label="Catégorie d'actifs Ijara"
                            name="CategorieActifsIjara"
                            Parametre={searchActif}
                        />
                    </Grid>
{/* 
                    <Grid item xs={12} md={6} lg={6}>
                        <SelectMultipleOptionPanier
                            form={props.form}
                            Size="large"
                            width={5}
                            label="Plan Paiement fournisseur"
                            name="Planfours"
                            Parametre={searchPlancp}
                        />
                    </Grid> */}

                    {/* Remplacement de ComptesRemboursementAuto par PlanRemAuto */}
                    <Grid item xs={12} md={6} lg={6}>
                        <SelectMultipleOptionPanier
                            form={props.form}
                            Size="large"
                            width={5}
                            label="Plan remboursement (PlanRemAuto)"
                            name="PlanRemAuto"
                            Parametre={searchPlancp}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={6}>
                        <SelectMultipleOptionPanier
                            form={props.form}
                            Size="large"
                            width={5}
                            label="Type de Garantie Autorisé"
                            name="TypeGarantieAuto"
                            Parametre={searchFinancement}
                        />
                    </Grid>
                </Grid>
            </Box>
        </div>
    );
}

export default Tab3;